

import { Injectable, Inject } from '@angular/core';
import { Observable, of, combineLatest, onErrorResumeNext, Subject } from 'rxjs';
// tslint:disable-next-line: max-line-length
import { DwMdFormActionHandler, DwMdFormActionState, DwMdFormActionResult, DwFormAction, DwSecuritySSOService, DwSecurityRepositoryServiceToken, DwSecurityRepositoryService, DwSecurityUserService, DwMdFormContextInfo, DwOrmDataService, DwOrmDataServiceToken } from '@devwareapps/devware-cap';
import { map, mergeMap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

import { LicensesEntity } from 'src/app/meta-data/app-meta-data.service';
import { ConfigService } from 'src/environments/environment';
import { FormGroup } from '@angular/forms';



@DwFormAction({
  name: 'SaveLicenses',
  actionKey : 'saveLicenses',
  actionMessage: 'Saving...',
  parentItemName : 'Licenses',
  useDi: true,
  buttonConfig : {
    buttonText : 'Save',
    buttonTitle : 'Save',
    command : 'saveLicenses',
    iconClass : '',
    buttonClass : 'btn btn-primary'
  }
})
@Injectable({
  providedIn: 'root'
})
export class LicensesSaveActionService implements DwMdFormActionHandler  {

   constructor(
     private msalHandler: DwSecuritySSOService,
      private securityService: DwSecurityUserService,
     @Inject(DwSecurityRepositoryServiceToken) private securityRepository: DwSecurityRepositoryService,
     @Inject(DwOrmDataServiceToken) private ormDataService: DwOrmDataService,
     private http: HttpClient) {
  }

  handleAction(formActionState: DwMdFormActionState): Observable<DwMdFormActionResult> {
    const result: DwMdFormActionResult = {
      success : true,
      message : 'Saved Successfully!',
    };
    const wachterUser = this.securityService.securityContext.ApplicationUser.Permissions;
    if (!wachterUser.includes('LICENSE_ADMIN')) {
      formActionState.formApi.patchFormData({StatusCv: 150});//Pending
    }
    return formActionState.formApi.saveData(true);
  }  
    //const ob = formActionState.formApi.saveData(true);
    // .pipe(flatMap(saveResult => {
        //     if (!saveResult.success) {
        //       return of(saveResult);
        //     }

        //     const request = saveResult.saveResult;
        //     console.log('Request', request);
        //     return request.StatusCv == 150  //Pending 
        //               ? this.sendEmail(request).pipe(map(() => { return result; }))
        //               : of(result); // Stop calling old API for Approved/Rejected/Closed. Email ported to template
        // }));
    //return ob;
  //}
  // sendEmail(request): Observable<any> {
  //   const url = ConfigService.config.wAppsApi + '/api/LicensesWorkflow';
  //   const resultOb = this.http.post(url, request);
  //   return resultOb;
  // }
}
